module.exports = __webpack_public_path__ + "static/media/homepage_service_scroll.3a597f0c.jpg";